import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-graph-dashboard',
  templateUrl: './graph-dashboard.component.html',
  styleUrls: ['./graph-dashboard.component.scss'],
})
export class GraphDashboardComponent implements OnInit {
  @ViewChild('containerRef', { static: true }) container!: ElementRef;

  //selectedView = 'whole_graph';
  selectedView = 'tech_only';
  fullGraphData: { nodes: any[]; links: any[] } = { nodes: [], links: [] };
  projectStats: {
    totalProjects: number | string;
    mainConcepts: number | string;
    subConcepts: number | string;
    domains: number | string;
    contributors: number | string;
  } = {
    totalProjects: '-',
    mainConcepts: '-',
    subConcepts: '-',
    domains: '-',
    contributors: '-',
  };

  ngOnInit() {
    // Not used currently, TODO: make a whole_graph view that is digestable and will be used with the LLM/chat filter feature
    fetch('assets/force_graph_data_projs1.json')
      .then((res) => res.json())
      .then((data) => {
        this.fullGraphData = data;
      });
  }

  onStatsChanged(stats: Partial<typeof this.projectStats>) {
    this.projectStats = { ...this.projectStats, ...stats };
  }
}
